if (typeof window.ShippingNotice !== 'function') {
  class ShippingNotice extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      var freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      var cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      var rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)
        ? Number(window.Shopify.currency.rate)
        : 1;

      var moneyFormat = (window.theme && window.theme.moneyFormat)
        || (window.Shopify && window.Shopify.money_format)
        || '£{{amount}}';

      var tiers = [];
      var tier1Cents = Math.round(freeShippingThreshold * (rate || 1));
      if (tier1Cents > 0) {
        tiers.push({
          cents: tier1Cents,
          label: this.getAttribute('data-tier1-label') || 'Free Shipping',
          messageName: this.getAttribute('data-tier1-message') || '',
          icon: this._truckIconSvg(),
          kind: 'shipping'
        });
      }
      var tier2Threshold = Number(this.getAttribute('data-tier2-threshold')) || 0;
      var tier2Label = this.getAttribute('data-tier2-label') || '';
      if (tier2Threshold > 0 && tier2Label) {
        tiers.push({
          cents: Math.round(tier2Threshold * (rate || 1)),
          label: tier2Label,
          messageName: this.getAttribute('data-tier2-message') || '',
          icon: this._giftIconSvg(),
          kind: 'gift'
        });
      }
      var tier3Threshold = Number(this.getAttribute('data-tier3-threshold')) || 0;
      var tier3Label = this.getAttribute('data-tier3-label') || '';
      if (tier3Threshold > 0 && tier3Label) {
        tiers.push({
          cents: Math.round(tier3Threshold * (rate || 1)),
          label: tier3Label,
          messageName: this.getAttribute('data-tier3-message') || '',
          icon: this._starIconSvg(),
          kind: 'bonus'
        });
      }

      tiers.sort(function (a, b) { return a.cents - b.cents; });
      if (!tiers.length) return;

      var startPct = 22;
      var endPct = 82;
      for (var p = 0; p < tiers.length; p++) {
        if (tiers.length === 1) {
          tiers[p].positionPct = 50;
        } else {
          tiers[p].positionPct = startPct + ((endPct - startPct) * p) / (tiers.length - 1);
        }
      }

      var lastReachedIdx = -1;
      for (var k = 0; k < tiers.length; k++) {
        if (cartTotal >= tiers[k].cents) lastReachedIdx = k;
      }

      var pct;
      if (lastReachedIdx === -1) {
        pct = tiers[0].cents > 0 ? (cartTotal / tiers[0].cents) * tiers[0].positionPct : 0;
      } else if (lastReachedIdx === tiers.length - 1) {
        pct = 100;
      } else {
        var prevTier = tiers[lastReachedIdx];
        var nextSegmentTier = tiers[lastReachedIdx + 1];
        var segSpan = nextSegmentTier.positionPct - prevTier.positionPct;
        var segProgress = nextSegmentTier.cents > prevTier.cents
          ? (cartTotal - prevTier.cents) / (nextSegmentTier.cents - prevTier.cents)
          : 0;
        pct = prevTier.positionPct + segProgress * segSpan;
      }
      pct = Math.max(0, Math.min(pct, 100));

      var nextTier = lastReachedIdx === tiers.length - 1 ? null : tiers[lastReachedIdx + 1];
      var allUnlocked = !nextTier;
      var message;
      var messageText = function (tier) {
        if (tier.messageName) return tier.messageName;
        return (tier.kind === 'shipping' ? '' : 'a free ') + tier.label;
      };
      if (allUnlocked) {
        var lastTier = tiers[tiers.length - 1];
        message = 'You’ve unlocked <strong>' + messageText(lastTier) + '</strong>!';
      } else {
        message = 'Add <strong>' + this._formatMoney(nextTier.cents - cartTotal, moneyFormat)
          + '</strong> more, unlock <strong>' + messageText(nextTier) + '!</strong>';
      }

      var markersHtml = '';
      for (var j = 0; j < tiers.length; j++) {
        var t = tiers[j];
        var unlocked = cartTotal >= t.cents;
        markersHtml += '<div class="shipping-bar__marker' + (unlocked ? ' is-unlocked' : '')
          + '" style="left:' + t.positionPct + '%;">'
          + '<span class="shipping-bar__marker-icon">' + t.icon + '</span>'
          + '<span class="shipping-bar__marker-label">' + t.label + '</span>'
          + '<span class="shipping-bar__marker-amount">' + this._formatMoney(t.cents, moneyFormat).replace(/\.00(?=\D|$)/, '') + '</span>'
          + '</div>';
      }

      this.innerHTML = ''
        + '<div class="shipping-bar shipping-bar--tiered ' + (allUnlocked ? 'shipping-bar--qualified' : '') + '">'
        +   '<button type="button" class="shipping-bar__close-btn" aria-label="Close">'
        +     '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
        +       '<path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'
        +     '</svg>'
        +   '</button>'
        +   '<p class="shipping-bar__message">' + message + '</p>'
        +   '<div class="shipping-bar__track">'
        +     '<div class="shipping-bar__fill" style="width:0%"></div>'
        +     markersHtml
        +   '</div>'
        + '</div>';

      var self = this;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var fill = self.querySelector('.shipping-bar__fill');
          if (fill) fill.style.width = pct + '%';
        });
      });

      if (allUnlocked) {
        this._confetti();
      }

      var upsellContainer = document.querySelector('[data-upsell-threshold]');
      if (upsellContainer) {
        upsellContainer.style.display = allUnlocked ? 'none' : '';
      }

      if (allUnlocked) {
        var ebookForm = document.getElementById('ebook-auto-add-form')
          || document.getElementById('ebook-auto-add-form-page');
        if (ebookForm) {
          var sKey = 'ebook_added_' + (ebookForm.getAttribute('data-cart-token') || 'default');
          try {
            if (!sessionStorage.getItem(sKey)) {
              ebookForm.submit();
              sessionStorage.setItem(sKey, '1');
            }
          } catch (e) { /* sessionStorage may be blocked — ignore */ }
        }
      }

    }

    _confetti() {
      var bar = this.querySelector('.shipping-bar');
      if (!bar) return;
      var colors = ['#c9a84c', '#d4b85e', '#4CAF50', '#fff', '#FFD700', '#FF6B6B', '#36D399'];
      var isMobile = window.innerWidth < 768;
      var count = isMobile ? 10 : 40;
      var container = document.createElement('div');
      container.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden;pointer-events:none;z-index:10';
      bar.style.position = 'relative';
      bar.appendChild(container);

      var fragment = document.createDocumentFragment();
      var pieces = [];
      for (var i = 0; i < count; i++) {
        var piece = document.createElement('div');
        var color = colors[Math.floor(Math.random() * colors.length)];
        var size = Math.random() * 8 + 4;
        var left = Math.random() * 100;
        var angle = (Math.random() - 0.5) * 120;
        var dist = Math.random() * 120 + 60;
        var dur = Math.random() * 800 + 800;
        var shape = Math.random() > 0.5 ? '50%' : '0';
        piece.style.cssText = 'position:absolute;bottom:50%;left:' + left + '%;width:' + size + 'px;height:' + size + 'px;background:' + color + ';border-radius:' + shape + ';opacity:1;will-change:transform,opacity;transform:translate3d(0,0,0) rotate(0deg);transition:transform ' + dur + 'ms cubic-bezier(0.25,0.46,0.45,0.94),opacity ' + dur + 'ms ease;pointer-events:none;';
        fragment.appendChild(piece);
        pieces.push({ el: piece, angle: angle, dist: dist });
      }
      container.appendChild(fragment);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          for (var j = 0; j < pieces.length; j++) {
            var p = pieces[j];
            var x = Math.sin(p.angle * Math.PI / 180) * p.dist;
            var y = -Math.abs(Math.cos(p.angle * Math.PI / 180)) * p.dist - 20;
            p.el.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) rotate(' + (Math.random() * 360) + 'deg)';
            p.el.style.opacity = '0';
          }
        });
      });

      setTimeout(function () { container.remove(); }, 2000);
    }

    _truckIconSvg() {
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
        + '<path d="M1 3h15v13H1V3z" fill="currentColor" fill-opacity="0"/>'
        + '<path d="M16 8h4l3 4v5h-3M16 16H1M1 3h15v13H1V3z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
        + '<circle cx="5.5" cy="18.5" r="2.5" fill="currentColor"/>'
        + '<circle cx="18.5" cy="18.5" r="2.5" fill="currentColor"/>'
        + '</svg>';
    }

    _giftIconSvg() {
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
        + '<rect x="3" y="9" width="18" height="12" rx="1.5" stroke="currentColor" stroke-width="1.5"/>'
        + '<path d="M3 13h18M12 9v12" stroke="currentColor" stroke-width="1.5"/>'
        + '<path d="M12 9c-2 0-4-1-4-3s1.5-2.5 3-2c1.5.5 1 5 1 5zM12 9c2 0 4-1 4-3s-1.5-2.5-3-2c-1.5.5-1 5-1 5z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>'
        + '</svg>';
    }

    _starIconSvg() {
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
        + '<path d="M12 3l2.7 5.5 6 .9-4.3 4.2 1 6L12 16.8 6.6 19.6l1-6L3.3 9.4l6-.9L12 3z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>'
        + '</svg>';
    }

    _formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || '${{amount}}';

      function defaultOption(opt, def) { return (typeof opt === 'undefined' ? def : opt); }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number === null) return 0;
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsStr = parts[1] ? decimal + parts[1] : '';
        return dollars + centsStr;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ', '');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }
      return formatString.replace(placeholderRegex, value);
    }
  }

  window.ShippingNotice = ShippingNotice;
  if (typeof customElements.get('shipping-notice') === 'undefined') {
    customElements.define('shipping-notice', ShippingNotice);
  }
}

(function () {
  if (window.__aeShippingBarCloseDelegated) return;
  window.__aeShippingBarCloseDelegated = true;

  function closeCartDrawer(ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('.shipping-bar__close-btn');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    var sidebar = document.getElementById('site-cart-sidebar');
    if (sidebar) {
      sidebar.classList.remove('sidebar--opened');
      sidebar.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('sidebar-opened');
    var overlay = document.querySelector('[data-js-sidebar-overlay]');
    if (overlay) overlay.classList.remove('is-active');
  }

  document.addEventListener('click', closeCartDrawer, true);
  document.addEventListener('touchend', closeCartDrawer, true);
})();
